import apiClient, { unwrap } from './client'
import type { DkimKey } from './types'

export const dkimApi = {
  list() {
    return unwrap<DkimKey[]>(apiClient.get('/dkim'))
  },

  generate(data: { domain: string; selector?: string; key_size?: number }) {
    return unwrap<{ domain: string; selector: string; dns_name: string; dns_record: string }>(
      apiClient.post('/dkim/generate', data),
    )
  },

  getDns(id: number) {
    return unwrap<{ domain: string; dns_name: string; dns_record: string }>(
      apiClient.get(`/dkim/${id}/dns`),
    )
  },

  delete(id: number) {
    return unwrap<{ deleted: number }>(apiClient.delete(`/dkim/${id}`))
  },
}
